/**
 * Helper to access Zudoku's authentication state store
 * This is a workaround since useAuthState is not exported in the public API
 */

// Type definitions matching Zudoku's UserProfile
interface UserProfile {
	sub: string;
	email: string | undefined;
	emailVerified: boolean;
	name: string | undefined;
	pictureUrl: string | undefined;
	[key: string]: string | boolean | undefined;
}

interface AuthStateActions {
	setLoggedIn: (data: { profile: UserProfile; providerData: any }) => void;
	setLoggedOut: () => void;
	setAuthenticationPending: () => void;
}

/**
 * Get the Zudoku auth state store from localStorage and window
 * This ONLY uses localStorage to avoid React context issues during initialization
 */
export function getAuthState(): AuthStateActions {
	if (typeof window === "undefined") {
		// Server-side: return no-op functions
		return {
			setLoggedIn: () => {},
			setLoggedOut: () => {},
			setAuthenticationPending: () => {},
		};
	}

	// Always use localStorage approach to avoid React context issues
	return {
		setLoggedIn: ({ profile, providerData }) => {
			const state = {
				state: {
					isAuthenticated: true,
					isPending: false,
					profile,
					providerData,
				},
				version: 0,
			};
			localStorage.setItem("auth-state", JSON.stringify(state));
			console.log("[AuthState] Set logged in state", { email: profile.email });
		},
		setLoggedOut: () => {
			const state = {
				state: {
					isAuthenticated: false,
					isPending: false,
					profile: null,
					providerData: null,
				},
				version: 0,
			};
			localStorage.setItem("auth-state", JSON.stringify(state));
			console.log("[AuthState] Cleared auth-state");
		},
		setAuthenticationPending: () => {
			const current = localStorage.getItem("auth-state");
			const parsed = current ? JSON.parse(current) : { state: {} };
			const state = {
				...parsed,
				state: {
					...parsed.state,
					isPending: true,
				},
				version: 0,
			};
			localStorage.setItem("auth-state", JSON.stringify(state));
			console.log("[AuthState] Set pending state");
		},
	};
}

export type { UserProfile };
